<script>
	import CustomInput from "src/components/CustomInput/CustomInput.svelte";
	import CustomSearch from "src/components/CustomSearch/CustomSearch.svelte";
	import { sveltyPickerFormat } from "src/services/helpers";
	import {
		isPhase3CaseOrigin,
		splitCamelCaseAndCapitalize,
	} from "src/utils/misc";
	import {
		collisionTypeOptions,
		damageAttributionOptions,
	} from "src/utils/options";
	import { Col, Row } from "@sveltestrap/sveltestrap";
	import SveltyPicker from "svelty-picker";
	import DamageInformationAttribution from "./DamageInformationAttribution.svelte";
	import CustomTextArea from "src/components/CustomTextArea/CustomTextArea.svelte";
	import DamageInformationVqp from "./DamageInformationVqp.svelte";

	export let form;
	export let dateReported;
	export let attribution;
	export let damageCause;
	export let damageCauseType;
	export let staffName;
	export let staffContact;
	export let thirdPartyName;
	export let thirdPartyContact;
	export let incidentDateTime;
	export let bidError = "";
	export let vqp;
	export let l1Remarks;
	export let caseDetails = {};

	$: isInvestigating = caseDetails.status === "Investigating";
</script>

<Col xs={12}>
	<Row class="mb-4">
		<Col xs={4}>
			<Row>
				<Col>
					<label for="dateReported" class="d-block">
						<span>
							Incident Date and Time<span class="text-danger"
								>*</span
							>
						</span>
					</label>
				</Col>
			</Row>
			<Row>
				<Col>
					<SveltyPicker
						inputClasses="form-control getgo input calendar-icon"
						format={sveltyPickerFormat}
						placeholder="Select a date and time"
						bind:value={$incidentDateTime.value}
						disableDatesFn={(date) => {
							const today = new Date();
							return date > today;
						}}
					/>
					{#if new Date($incidentDateTime.value) > new Date()}
						<div class="text-danger mt-1">
							Incident date cannot be in the future
						</div>
					{/if}
					{#if $form.hasError("incidentDateTime.required")}
						<div class="text-danger mt-1">
							Incident date and time is required
						</div>
					{/if}
				</Col>
			</Row>
		</Col>
	</Row>
	<DamageInformationAttribution
		{attribution}
		{damageCause}
		{damageCauseType}
		{staffName}
		{staffContact}
		{thirdPartyName}
		{thirdPartyContact}
		{form}
		{bidError}
	/>

	<Row class="mb-4">
		<Col xs={5}>
			<Row>
				<Col>
					<label for="collisionType" class="d-block">
						<span>
							Type of collision<span class="text-danger">*</span>
						</span>
					</label>
				</Col>
			</Row>
			<Row>
				<Col>
					<CustomSearch
						isSearchable={false}
						items={collisionTypeOptions}
						placeholder="Select collision type"
						bind:value={$damageCauseType.value}
						error={$form.hasError("damageCauseType.required")}
						errorText="Collision type is required"
					/>
				</Col>
			</Row>
		</Col>
	</Row>
	<DamageInformationVqp {vqp} {caseDetails} />
	{#if isInvestigating && (isPhase3CaseOrigin(caseDetails.createdFrom) || isPhase3CaseOrigin(caseDetails.caseOrigin))}
		<Row>
			<Col xs={12}>
				<Row>
					<Col>
						<label for="vqp" class="d-block">
							<span>
								L1 Remarks<span class="text-danger">*</span>
							</span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col>
						<CustomTextArea
							bind:value={$l1Remarks.value}
							maxlength={3000}
							placeholder="Enter remarks"
							error={$form.hasError("l1Remarks.required")}
							errorText={"Remarks is required."}
						/>
					</Col>
				</Row>
			</Col>
		</Row>
	{/if}
</Col>
